/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import "./add-content.scss";
import Switch from "react-switch";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import {
    // showSideBar,
    getSubtopicResources,
    resetResourceLoading,
    googleLinkPreviewSetNull,
    googleLinkPreview,
    changeResourceStatus,
    addLink,
    reorderSubTopicsResources,
    reorderdSubTopicsResources,
    handleChangeSource,
    updateContent
} from "../../../../ActionCreators/AdminAction/manageSkillpathAction";
import { clearErrors } from "../../../../ActionCreators/errorAction";
import Snackbar from '@mui/material/Snackbar';
import Modal from "react-bootstrap/Modal";
import PreviewLink from "./previewLink";
import FeedsPopup from '../../../Feeds-popup/feedpopup';
import $ from 'jquery';
import { TopicLoader } from "../../../../Loader/loader";
import { Fragment } from "react";


class AddContent extends Component {
    constructor(props, context) {
        super(props);
        this.state = {
            checked: false,
            articleLink: "",
            isView: false
        };
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0);
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        };
        console.log(this.props.history.location.state)
        this.props.clearErrors();
        this.setState({
            topicId: this.props.history.location.state.topicId,
            title: this.props.history.location.state.title,
            subtopicId: this.props.history.location.state.id,
            skillId: this.props.history.location.state.skillId,
            skillPathId: this.props.history.location.state.skillPathId,
        }, async () => {
            await this.props.resetResourceLoading();
            // this.props.addParams(this.state.topicId, this.state.title, this.state.topic);
            await this.props.getSubtopicResources(this.state.topicId, this.state.title);
        });

        // await this.props.hideSideBar();
        // this.props.getTopicListOfSubject(this.props.history.location.state.subjectId);
    };

    handleChange = (type, id, checked) => {
        this.setState({
            checked: !checked
        }, () => {
            this.props.changeResourceStatus(type, id, this.state.skillPathId, this.state.topicId, this.state.subtopicId, checked)
        })
    }

    backtoBubble = () => {
        this.props.history.goBack();
        // this.props.hideSideBar();
    };

    handleVideo = (type) => {
        this.props.history.push({
            pathname: "/manage-skillpath/subtopic/add-content/add-resource",
            state: {
                subtopic: this.state.title,
                topic: this.state.topic,
                type: type,
                topicId: this.state.topicId,
                skillId: this.state.skillId,
                edit: false,
                skillPathId: this.state.skillPathId,
            },
        });
    };

    handleQuiz = (type) => {
        this.props.history.push({
            pathname: "/manage-skillpath/subtopic/add-content/add-resource",
            state: {
                subtopic: this.state.title,
                topic: this.state.topic,
                type: type,
                topicId: this.state.topicId,
                skillId: this.state.skillId,
                edit: false,
                skillPathId: this.state.skillPathId,
                skill: this.props.history.location.state.skill
            },
        });

    }

    addArticle = (type) => {
        this.setState({
            isAddArticle: true,
            edit: false,
            type
        });
    };

    addPodcast = (type) => {
        this.setState({
            isAddArticle: true,
            edit: false,
            type
        });
    }

    handleModal = () => {
        this.setState({
            isAddArticle: false,
            articleLink: ''
        });
        this.props.googleLinkPreviewSetNull();
    };


    handleChangeArticle = async (evt) => {
        var regex =
            /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-/]))?/;
        var Extension = evt.target.value
            .substring(evt.target.value.lastIndexOf(".") + 1)
            .toLowerCase();
        if (!regex.test(evt.target.value)) {
            this.setState({
                articleError: "Please enter valid link",
            });
            this.props.googleLinkPreviewSetNull();
            return false;
        }
        else if (Extension === 'pdf') {
            this.setState({
                articleError: "Please enter article link",
            });
        }
        else {
            this.props.googleLinkPreview(evt.target.value);
            this.setState({ articleError: "", articleLink: evt.target.value });
        }
    };



    articleLinkASave = async (type) => {
        if (this.state.articleLink === "" || null) {
            this.setState({
                articleError: "Link cannot be empty",
            });
        }
        else if (this.props.articleSource === '') {
            this.setState({
                sourceError: "Please enter the source",
            });
        }
        else if (!this.props.previewData) {
            this.setState({
                articleError: "Please enter the link",
            });
        } else {
            var obj = {
                _id: this.state.skillPathId,
                topic_id: this.state.topicId,
                subtopic: this.state.title,
                description: this.props.previewData?.description,
                title: this.props.previewData?.title,
                image: this.props.previewData?.image,
                type: type === 'Article' ? 'Article' : type === 'Podcast' ? 'Podcast' : 'Video',
                url: this.props.previewData?.url,
                skill_id: this.state.skillId,
                source: this.props.articleSource
            }
            await this.props.addLink(obj);
            if (this.props.successEnable) {
                this.props.googleLinkPreviewSetNull();
                this.setState({
                    isAddArticle: false,
                    articleLink: '',
                });
            }
        }
    };

    updateArticle = async () => {
        if (this.state.articleLink === "" || null) {
            this.setState({
                articleError: "Link cannot be empty",
            });
        }
        else if (this.props.articleSource === '') {
            this.setState({
                sourceError: "Please enter the source",
            });
        }
        else if (!this.props.previewData) {
            this.setState({
                articleError: "Please enter the link",
            });
        } else {
            var data = new FormData();
            data.append('topic_id', this.state.topicId)
            data.append("_id", this.state.id);
            data.append("description", this.props.previewData.description);
            data.append("title", this.props.previewData.title);
            data.append("image", this.props.previewData.image);
            data.append("type", this.state.type);
            data.append("url", this.props.previewData.url);
            data.append("source", this.props.articleSource);
            await this.props.updateContent(data);
            // const obj = {
            //   id: this.state.topicId,
            //   title: this.state.title,
            // };
            await this.props.getSubtopicResources(this.state.topicId, this.state.title);
            await this.props.googleLinkPreviewSetNull();
            this.setState({
                isAddArticle: false,
            });
        }
    };

    editResources = (details) => {
        if (details.type === "Article" || details.type === "Podcast") {
            this.props.googleLinkPreview(details.url);
            this.setState({
                isAddArticle: true,
                edit: true,
                articleLink: details.url,
                id: details._id,
                type: details?.type
            });
        } else {
            this.props.history.push({
                pathname: "/manage-skillpath/subtopic/add-content/add-resource",
                state: {
                    title: this.props.history.location.state.title,
                    topic: this.props.history.location.state.topic,
                    type: details.type,
                    details: details,
                    topicId: this.state.topicId,
                    skillId: this.state.skillId,
                    edit: true,
                    skillPathId: this.state.skillPathId,
                },
            });

        }
    };

    snackClosed = () => {
        this.props.clearErrors();
    };

    backToSubject = () => {
        this.props.history.goBack();
        this.props.history.goBack();
        this.props.history.goBack();
    };

    backToTopic = () => {
        this.props.history.goBack();
        this.props.history.goBack();
    };



    // backToTopic = () => {
    //   this.props.history.goBack();
    //   this.props.history.goBack();
    // };

    goToSubTopicsContent = async (id, title) => {
        this.setState({
            title: title,
            topicId: id,
        }, () => {
            this.props.addParams(this.state.topicId, this.state.title, this.state.topic)
        });
        const data = {
            id,
            title,
        };
        await this.props.resetResourceLoading();
        // await this.props.hideSideBar()
        await this.props.getResourcesList(data);
    }

    checkFocus = () => {
        // dummy element
        var dummyEl = document.getElementById("express-form-typeahead");
        // check for focus
        var isFocused = document.activeElement === dummyEl;

        if (isFocused) {
            this.setState({
                isFocused,
            });
        } else {
            this.setState({
                isFocused: false,
            });
        }
    }

    handleDragEnd = async (result) => {
        if (!result.destination) return
        await this.props.reorderSubTopicsResources(result)
        await this.props.reorderdSubTopicsResources(this.state.topicId, this.state.title, this.props.resourceList.map(el => [{ _id: el._id, index: el.index }][0]))
    }

    openView = (el) => {
        this.setState({
            isView: true,
            resource: el
        })
        $("body").css("overflow", "hidden");
    }

    closeDetails = () => {
        this.setState({
            isView: false,
            resource: {}
        })
        $("body").css("overflow", "visible");
    }

    render() {
        const { previewData, resourceList, isResourceLoading, theme, successEnable, successMessage, successMessageText } = this.props;

        return (
            <Fragment>

                <div className="subtopics-module" style={{ marginLeft: window.innerWidth > 767 ? -50 : -12 }}>
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                        open={successMessage}
                        onClose={() => this.snackClosed()}
                        message={successMessageText}
                        autoHideDuration={4000}
                    />
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                        open={successEnable}
                        onClose={() => this.snackClosed()}
                        message={successMessageText}
                        autoHideDuration={4000}
                    />
                    <div className="manage-subtopics add-content-wrapper p-0" style={{ width: window.innerWidth > 767 ? '90%' : '100%' }}
                    >
                        <div className="d-flex" style={{ fontSize: 20, cursor: "pointer" }}>
                            <p style={{ marginTop: 5 }} onClick={() => this.backtoBubble()}>
                                <img src='/images/back1.svg' alt='' width={24} />
                            </p>
                            &nbsp;&nbsp;
                            <h1>{this.state.title}</h1>
                        </div>
                        <div className='subject-header'>
                            <ul className='subject-btn'>
                                <li><button className='active' style={{ backgroundColor: theme?.bgColor }} onClick={() => this.handleVideo("Video")}><img src='/images/video-icon-white.svg' alt='' /> &nbsp; Add Video</button></li>
                                <li><button className='active' style={{ backgroundColor: theme?.bgColor }} onClick={() => this.addArticle('Article')}><img src='/images/article-icon-white.svg' alt='' /> &nbsp; Add Article</button></li>
                                <li><button className='active' style={{ backgroundColor: theme?.bgColor }} onClick={() => this.handleVideo("Document")}><img src='/images/document-icon-white.svg' alt='' /> &nbsp; Add Document</button></li>
                                {/* <li><button className='active' onClick={() => this.addPodcast('Podcast')}><img src='/images/podcast-icon-white.svg' alt='' /> &nbsp; Add Podcast</button></li> */}
                                <li><button className='active' style={{ backgroundColor: theme?.bgColor }} onClick={() => this.handleQuiz("quiz", false)}><img src='/images/question-white.svg' alt='' /> &nbsp; Add Quiz</button></li>
                            </ul>

                            <div className='content-heading'>
                                <ul>
                                    <li>
                                        <div>No.</div>
                                        <div>Item</div>
                                        <div>Item Type</div>
                                        <div>Status</div>
                                        <div style={{ width: '18%' }}>Actions</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {
                            <DragDropContext onDragEnd={this.handleDragEnd}>
                                <Droppable droppableId={this.state.topicId}>
                                    {
                                        (provided) => (
                                            <ul className='subject-list' {...provided.droppableProps} ref={provided.innerRef} >
                                                {isResourceLoading ?
                                                    <TopicLoader />
                                                    :
                                                    resourceList !== undefined && resourceList.length > 0 ?
                                                        resourceList.map((el, index) => {
                                                            return (
                                                                <Draggable key={el._id} draggableId={el._id} index={index} >
                                                                    {
                                                                        (provided) => (
                                                                            <li {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                                                                <div className='subject-num' >
                                                                                    <img src='/images/drag.svg' alt='' style={{ verticalAlign: 'middle' }} />
                                                                                    <p>{index + 1}</p>
                                                                                </div>
                                                                                <div className='subject-name ml-0' style={{ width: '44%' }} >
                                                                                    <div className="d-flex align-items-center">
                                                                                        <article style={{ width: '56px' }}>
                                                                                            <img
                                                                                                src={el.type === 'Quiz' ? '/images/quiz-icon.svg' : el.type === 'Document' ? (!el.image ? '/images/empty-image.svg' : el.image) : el.image !== null ? el.image : '/images/empty-image.svg'}
                                                                                                alt=""
                                                                                                className="rounded"
                                                                                                width="56px "
                                                                                                height="32px"
                                                                                            // onError={(e) => {
                                                                                            //     if (e.target.src !== "/images/error-image.jpg") {
                                                                                            //         e.target.onerror = null;
                                                                                            //         e.target.src = "/images/error-image.jpg";
                                                                                            //     }
                                                                                            // }
                                                                                            // }
                                                                                            />
                                                                                        </article> &nbsp;
                                                                                        <p style={{ marginLeft: "17px", lineHeight: "normal" }}>
                                                                                            {el.title}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className='text-center ' style={{ width: '18%', cursor: 'default' }} >
                                                                                    <h3 className='d-flex justify-content-start align-items-center'>
                                                                                        {el.type === "Video" ?
                                                                                            <img
                                                                                                src="/images/video-color-icon.svg" alt='' /> : el.type === "Article" ?
                                                                                                <img
                                                                                                    src="/images/article-color-icon.svg" alt='' /> : el.type === "Quiz" ? <img
                                                                                                        src="/images/quiz.svg" alt='' width={20} height={20} /> : el.type === "Document" ? <img
                                                                                                            src="/images/document-color-icon.svg" alt='' /> : el.type === "Podcast" ?
                                                                                                    <img src="/images/podcast-color-icon.svg" alt='' /> :
                                                                                                    el.type === "Course" ? <img
                                                                                                        src="/images/course-color-icon.svg" alt='' /> :
                                                                                                        null}
                                                                                        &nbsp; &nbsp;
                                                                                        {el.type}</h3>
                                                                                </div>

                                                                                <div className='text-center'>
                                                                                    <p> <Switch onChange={() => this.handleChange(el.type, el._id, el.active)}
                                                                                        width={30}
                                                                                        height={16}
                                                                                        uncheckedIcon={false}
                                                                                        checkedIcon={false}
                                                                                        onColor='#00B24B'
                                                                                        checked={el.active} /><br />
                                                                                        {el.active ? 'Active' : 'Inactive'}
                                                                                    </p>
                                                                                </div>
                                                                                <div className='text-center'>
                                                                                    {el.type === "Quiz" ? null : <img src="/images/view-icon.svg" alt="" width='25px' onClick={() => this.openView(el)} />}
                                                                                    {/* {this.props.history.location.state.clone ?null:<img src="/images/edit-pencil.svg" onClick={() => this.editResources(el)} alt="" />} */}
                                                                                    {/* <img src='/images/delete.svg' alt='' />&nbsp;&nbsp;
                                           <img src='/images/menu.svg' alt='' /> */}
                                                                                </div>
                                                                            </li>
                                                                        )}
                                                                </Draggable>
                                                            )
                                                        })
                                                        : <div className='empty-list'>
                                                            <img src='/images/empty.png' alt='' />
                                                            <p>You have not added any resources  yet.</p>
                                                        </div>

                                                }
                                            </ul>
                                        )}
                                </Droppable>
                            </DragDropContext>
                        }

                    </div>
                    <div className="feeds-details" style={{ display: this.state.isView ? 'block' : 'none', }}>
                        <FeedsPopup
                            activeFeedData={this.state.resource}
                            // saveNote={this.saveNote}
                            // likeClick={this.likeClick}
                            closePopup={this.closeDetails}
                        />
                    </div>
                    <Modal
                        {...this.props}
                        show={this.state.isAddArticle}
                        size="md"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        // onHide={this.handleModal}
                        dialogClassName={"add-topic-modal"}
                    >
                        <div className="modal-header" style={{ background: theme?.bgColor }}>
                            <h5 className="modal-title">
                                {this.state.type === 'Article' ?
                                    (this.state.edit ? 'Edit Article' : 'Add Article')
                                    : (this.state.edit ? 'Edit Podcast' : 'Add Podcast')
                                }
                                <br />
                            </h5>

                            <div className="sticky-close" style={{ top: 14 }} onClick={() => this.handleModal()}>
                                <img src="/images/close-white.svg" width="15px" alt="" />
                            </div>
                        </div>
                        <Modal.Body style={{ padding: "22px 40px 22px 40px" }}>
                            <div>
                                <label>{this.state.type === 'Article' ? 'Article Link*' : 'Podcast Link*'}</label>
                                <input
                                    className="form-control mt-2"
                                    value={this.state.articleLink}
                                    onChange={(e) => this.handleChangeArticle(e)}
                                />
                                {previewData ? (
                                    <PreviewLink previewData={this.props.previewData} />
                                ) : null}
                            </div>
                            <small>{this.state.articleError}</small>
                            <div className="mt-2">
                                <label>Source*</label>
                                <input
                                    className="form-control mt-2"
                                    value={this.props.articleSource}
                                    onChange={(e) => this.props.handleChangeSource(e.target.value)}
                                />
                            </div>
                            <small>{this.state.sourceError}</small>
                            <div className="save-btn">
                                {
                                    this.state.edit ?
                                        <button style={{ backgroundColor: theme?.bgColor }} onClick={() => this.updateArticle(this.state.type)}>Save</button> :
                                        <button style={{ backgroundColor: theme?.bgColor }} onClick={() => this.articleLinkASave(this.state.type)}>Save</button>
                                }&nbsp;&nbsp;
                                <button onClick={this.handleModal}>Cancel</button>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const { subTopics, previewData, resourceList, articleSource, isResourceLoading, topic_id, title, topic } = state.manageSkillpath;
    const { theme } = state.account
    const { successMessageText, successMessage, successEnable } = state.error;
    return {
        isResourceLoading, resourceList, previewData, articleSource, subTopics, topic_id, title, topic, theme,
        successEnable, successMessage, successMessageText,
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getSubtopicResources, resetResourceLoading, changeResourceStatus, googleLinkPreviewSetNull, googleLinkPreview, addLink, reorderSubTopicsResources, reorderdSubTopicsResources, handleChangeSource, updateContent,
        clearErrors,
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddContent));
